export const PAGE_SIZE = 50;

// key: row field / column id. sortKey: server sort param (null = not sortable).
export const ALL_COLUMNS = [
  { key: 'artist', label: 'Artist', locked: true, sortKey: 'name' },
  { key: 'last_show', label: 'Last show', sortKey: 'last_show' },
  { key: 'status', label: 'Status', sortKey: 'status' },
  { key: 'avg_cap', label: 'Avg cap 12mo', meta: 'Number', sortKey: 'avg_cap', numeric: true },
  { key: 'facebook', label: 'Facebook', meta: 'Number', sortKey: 'facebook', numeric: true },
  { key: 'spotify', label: 'Spotify', meta: 'Number', sortKey: 'spotify', numeric: true },
  { key: 'genre', label: 'Genre', sortKey: null },
  { key: 'agency', label: 'Agency', sortKey: null },
];

export const DEFAULT_VISIBLE = ['artist', 'last_show', 'status', 'avg_cap', 'facebook', 'spotify'];

export const STATUS_OPTIONS = [
  { key: 'on_tour', label: 'On tour' },
  { key: 'off_tour', label: 'Off tour' },
];
export const DEFAULT_STATUS = STATUS_OPTIONS.map((o) => o.key);

// History = artist has a calendar event for this team.
export const HISTORY_OPTIONS = [
  { key: 'yes', label: 'Yes' },
  { key: 'no', label: 'No' },
];
export const DEFAULT_HISTORY = HISTORY_OPTIONS.map((o) => o.key);

// Last performed = artist's most recent show anywhere (artists.last_show_date).
// Keys are months, matching the server's whitelisted last_show_within windows.
export const LAST_SHOW_OPTIONS = [
  { key: '12', label: 'Past year' },
  { key: '24', label: 'Past 2 years' },
  { key: '60', label: 'Past 5 years' },
  { key: 'any', label: 'Any time' },
];
export const DEFAULT_LAST_SHOW = 'any';

// ponytail: slider bounds hardcoded (coarse filters). Upgrade to server-computed
// min/max if the real distributions make these ranges feel wrong.
export const SLIDERS = [
  { key: 'avgCap', param: 'avg_cap', title: 'Avg cap (12 mo)', min: 0, max: 30000, step: 500 },
  { key: 'facebook', param: 'facebook', title: 'Facebook followers', min: 0, max: 5000000, step: 10000 },
  { key: 'spotify', param: 'spotify', title: 'Spotify followers', min: 0, max: 10000000, step: 10000 },
];
